'use client';

import Image from "next/image";
import {Suspense, useRef, useState} from "react";

type TeamType = {
    name: string | null
    city?: string | null
    odds?: number
    image?: string | null
    alt?: string
    guest?: boolean|null
    isHome?: boolean|null
}
export default function Team({name, city, odds, image, alt, isHome = false}: TeamType) {
    const [loaded, setLoaded] = useState(false);
    return (
        <div className={`game-team ${isHome ? 'm-guest' : 'm-home'}`}>
            <div className="team-details">
                <div className="team-name">
                    <span className="name">{name}</span>
                </div>
                {odds &&
                  <div className="team-odds">{odds}</div>
                }
            </div>
            {image && image?.length > 0 &&
                <Suspense fallback={<p>loading</p>}>
                  <Image
                      className="team-logo"
                      priority
                      src={image ?? ''}
                      alt={alt ?? 'Logo'}
                      width={80}
                      height={80}
                  />
                </Suspense>
            }
        </div>
    )
}
